import { format } from 'date-fns';
import { validateControlQuestions } from './Validate';
import React, { useState } from 'react';
import { useChosenCharity } from '../../../../traits/context/chosenCharity';
import { useNavigate, useParams } from 'react-router-dom';
import { useChosenPublicCharity } from '../../../../traits/context/chosenPublicCharity';
import { MainButton, SecondaryButton } from '@expo/ui/src/buttons';
import { Input, Checkbox } from '@expo/ui/src/inputs';
import { Margin } from '@expo/ui/src/layout';
import { H4, ErrorText } from '@expo/ui/src/typography';
import { AgreementInfo } from '../../home/common/types/AgreementInfo';

export type ControlQuestion = { checked: boolean; label: string; id: number };

export const SignAgreementForm = ({
  onNext,
  agreementInfo,
}: {
  onNext: () => void;
  agreementInfo: Omit<AgreementInfo, 'emailVerification'>;
}) => {
  const defaultControlQuestions: ControlQuestion[] = [
    {
      checked: false,
      label: 'Visade representanten sitt ID?',
      id: 0,
    },
    {
      checked: false,
      label: 'Jag har förstått att detta är ett månatligt givande',
      id: 1,
    },
  ] as const;

  const navigate = useNavigate();
  const { chosenCharity } = useChosenCharity();
  const { chosenCharity: chosenPublicCharity } = useChosenPublicCharity();
  const { slug } = useParams();

  const now = new Date();
  const datePlaceholder = format(now, 'yyyy/MM/dd');

  const [error, setError] = useState<string | null>(null);
  const [date, setDate] = useState('');

  const customControlQuestions = chosenCharity?.controlQuestions ?? chosenPublicCharity?.controlQuestions;
  const parsedCustomerControlQuestions =
    customControlQuestions?.map(({ question }, id) => ({
      checked: false,
      label: question,
      id,
    })) ?? [];
  const hasCustomQuestions = parsedCustomerControlQuestions.length > 0;
  const [controlQuestions, setControlQuestions] = useState(
    hasCustomQuestions ? parsedCustomerControlQuestions : defaultControlQuestions,
  );

  const onSubmit = () => {
    const { valid, errors } = validateControlQuestions({
      controlQuestions,
      date,
    });
    if (!valid) return setError(errors[0]);
    onNext();
  };

  return (
    <>
      <Margin $top="m" />
      <H4>Datum</H4>
      <Margin $top="s" />
      <Input
        type="date"
        charityStyles={chosenCharity ?? chosenPublicCharity}
        value={date}
        onChangeText={setDate}
        placeholder={datePlaceholder}
      />

      <Margin $top="m" />
      <H4>Kontrollfrågor</H4>
      <Margin $top="s" />
      {controlQuestions.map(question => (
        <React.Fragment key={question.id}>
          <Margin $top="m" />
          <Checkbox
            checked={question.checked}
            onValueChange={checked => {
              const newQuestions = controlQuestions.map(q => {
                if (q.id !== question.id) {
                  return q;
                }
                return { ...q, checked };
              });

              setControlQuestions(newQuestions);
            }}
            label={question.label}
          />
        </React.Fragment>
      ))}

      <Margin $top="xl" />
      {error ? (
        <>
          <ErrorText>{error}</ErrorText>
          <Margin $top="s" />
        </>
      ) : (
        <></>
      )}
      <MainButton charityStyles={chosenCharity ?? chosenPublicCharity} onClick={onSubmit}>
        Gå vidare till signering
      </MainButton>

      <Margin $top="m" />
      <SecondaryButton
        onClick={() => {
          navigate(`/${slug}?saleId=${agreementInfo.saleId}`);
          window.location.reload();
        }}
      >
        Tillbaka
      </SecondaryButton>
    </>
  );
};
